import { useI18n } from 'vue-i18n'
import columnStore from '@/stores/column'

export default function useInstanceColumns() {
	const i18n = useI18n()
	const cols = columnStore()

	const name = cols.define('instances', 'name', i18n.t('misc.name'), true)
	const description = cols.define('instances', 'description', i18n.t('description'), false)
	const address = cols.define('instances', 'address', i18n.t('address'), false)
	const email = cols.define('instances', 'email', i18n.t('email'), true)
	const phone = cols.define('instances', 'phone', i18n.t('phone'), true)
	const contact = cols.define('instances', 'contact', i18n.t('contact'), true)

	const columns = { name, description, address, email, phone, contact }

	const { custom, all } = cols.finalize('instances', columns, true)

	return { columns, custom, all }
}
